import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { v4 as uuid } from 'uuid';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import { useSelector } from "react-redux";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CircularProgress from '@mui/joy/CircularProgress';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import axios from 'axios';
import { AssessmentIcon, DocumentIcon, FolderIcon, TickHere, VideoIcon } from '../../../assets/icons/iconshere';
import { humanReadable } from '../../../utils/useWindowDimensions';
import { defaultLogo } from '../../../env';
import Skeleton from 'react-loading-skeleton';
import Player from './Player';
import LottiePlayer from "lottie-react";
import NoDataFoundAnim from '../../../assets/animationicons/nodatafound.json';
import { BpIcon, BpCheckedIcon } from '../../../utils/useWindowDimensions';
import NoDataFound from '../../NoDataFound';
import { InfoIcon } from '../../../SvgIconsData';

let assetTypeIcon = {
  "quiz": <AssessmentIcon />,
  "video": <VideoIcon />,
  "pdf": <DocumentIcon />,
  "ppt": <DocumentIcon />
}

const LMSPlay = ({ moduleDetails }) => {
  let params = useParams();
  const moduleUUID = params.uuid;
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [loading, setLoading] = useState(true);
  const [listLoading, setListLoading] = useState(true);
  const [dropdown, setDropdown] = useState([]);
  const [list, setList] = useState([]);
  const [sessionData, setSessionData] = useState({
    data: [],
    progress: 0
  });
  const [playerContent, setPlayerContent] = useState(null);
  const [fileType, setFileType] = useState("");

  const handleClickDropdown = (index) => {
    setDropdown((prev) => {
      if (prev.includes(index)) {
        return prev.filter((item) => item !== index);
      } else {
        return [...prev, index];
      }
    });
  }

  const handleClickDownloadFile = (url) => {
    let fileName = url.split('/').pop();
    let fileExt = fileName.split('.').pop();

    fetch(url).then(response => response.blob()).then(blob => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.download = uuid() + "." + fileExt;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch(error => {
        console.error(error);
      });
  };

  const handleClickGetContent = async (uuid) => {
    try {
      fetchPreviousSession();
      const { data } = await axios.get(`${configData.config.UNO_URL}/api/resource/2d/lms/player/content/${uuid}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        }});
      setPlayerContent(data.data);
      setFileType(data?.data?.assetLink?.split('.')?.pop() || "")
    } catch (error) {
      console.log(error);
    }

  }

  const handleClickPlay = async () => {
    handleClickGetContent(list[0]?.children[0]?.uuid || null);
    handleClickDropdown(0);
  }
  
  const fetchPreviousSession = async () => {
    try {

      const { data } = await axios.get(`${configData.config.API_URL}/api/2D/lms/get/last/session/${moduleDetails.uuid}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        }
      });

      setSessionData(data.data);

    } catch (error) {
      console.log(error);
    }
  }

  const getPlayerContentList = async() =>{
    try {
      setListLoading(true);
      const { data } = await axios.get(`${configData.config.UNO_URL}/api/resource/2d/lms/player/content/list/${moduleUUID}`,  {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        }});

        setList(data?.data?.children || [])

    } catch (error) {
      console.log(error);
    }finally{
      setListLoading(false);
    }
  }

  useEffect(() => {
    if (moduleDetails?.uuid) {
      setLoading(false);
      fetchPreviousSession();
      getPlayerContentList()
    }
  }, [moduleDetails]);

  const sectionTotalComplete = (list) => {
    if(list.length === 0 ) return 0;
    let progressValues = list.map((item) => sessionData.data.find((e) => e.id === item.uuid)?.progress || 0 );   
    if(progressValues.length === 0 ) return 0;
    let totalComplete = progressValues.reduce((acc, current) => acc + current, 0);
    let totalPossible = list.length * 100;        // assuming 100% is the maximum possible
    let percentageComplete = (totalComplete / totalPossible) * 100;
    return parseInt(percentageComplete);
  }
  
  return (
    <>
      <div className="module-frame lms container position-relative">

        <div className="playscreen ps-0" style={{ boxShadow: "none" }} >
          {loading ?
            <>
              <div className='frame-parent'>
                <div className='frame-details'>
                  <div className="loader">
                    <div className="cube">
                      <div className="face"></div>
                      <div className="face"></div>
                      <div className="face"></div>
                      <div className="face"></div>
                      <div className="face"></div>
                      <div className="face"></div>
                    </div>
                  </div>
                </div>
              </div>
            </>
            :
            <>
              {playerContent ?
                <Player playerContent={playerContent} id={moduleDetails.uuid} fileType={fileType} fetchPreviousSession={fetchPreviousSession} />
                :
                <div className='frame-parent'>
                  <div className={moduleDetails?.versions[0]?.data?.thumbnail ? "playscreen-frame" : "playscreen-frame no-bg"} style={{ backgroundImage: `url(${moduleDetails?.versions[0]?.data?.thumbnail ? moduleDetails?.versions[0]?.data?.thumbnail : defaultLogo})` }} >
                    <div className="black-overlay"></div>
                    <div className='frame-details'>
                      <h5 id="name">{moduleDetails.name} </h5>
                      <p id="description" className='info-here'>
                        {moduleDetails?.versions[0]?.data?.short}
                      </p>
                      {list.length > 0 &&
                      <div className='frame-btns mt-4'>
                        <button id="plybtn" onClick={(event) => handleClickPlay(event)}  > Start </button>
                      </div> }
                    </div>
                  </div>
                </div>
              }
            </>
          }
        </div>

        <div className='module-info'>
          <div className='head-info'> Course Content  </div>
          <div className='lessons-data'>
            {listLoading ? 
            <>
             {Array.from({length:3}).map((_,index)=>(
                <div key={index+1} className='lesson-item py-3 px-2 ps-4 flex-row d-flex gap-3'>
                  <Skeleton count={1} circle height="3rem" width="3rem" />
                  <div className='w-100 pt-1' >
                  <Skeleton width="80%" />    
                  <Skeleton width="80%" />    
                  </div>
                </div>
             ))}
            </>
            :
            list.length > 0 ?
                list.map((section, index) => {
                  let duration = section.children.map((e) => parseFloat(e.versions[0].data.courseDuration)).filter((value) => !isNaN(value)).reduce((acc, current) => acc + current, 0)
                  let totalProgress = parseInt(sectionTotalComplete(section.children));
              
                  return (
                    <div key={section.uuid} className='lesson-item'>

                      <div className='lesson-head' onClick={() => handleClickDropdown(index)}>
                        <div className='d-flex align-items-center gap-2 justify-content-center'>

                          {totalProgress === 100 ?
                          <span className='checked-icon' style={{ scale:"1.2", margin:"6px" }}>
                            <TickHere />
                          </span>
                          : 
                          <CircularProgress  size="md" variant='solid' thickness={5} determinate value={totalProgress} title ={totalProgress + "%"} ></CircularProgress>
                          }
                          <span >
                            <h5>{section.name}</h5>
                            <span className='small-details'> <p>{section.children.length} Sections</p> <p> {humanReadable(duration * 60)} </p> </span>
                          </span>
                        </div>
                        <span>
                          <span className='icon'>{dropdown.includes(index) ? <RemoveOutlinedIcon /> : <AddOutlinedIcon />}</span>
                        </span>
                      </div>

                      {dropdown.includes(index) &&
                        <div className='lesson-child'>
                          {section.children.map((subSection, indx) => {

                            let progress = parseInt(sessionData.data.find((e) => e.id === subSection.uuid)?.progress || 0);

                            return (
                              <div key={subSection.uuid} className={subSection.uuid === playerContent?.uuid ? 'lesson-child-item active' : "lesson-child-item"} onClick={() => handleClickGetContent(subSection.uuid)}>
                                <div className='lesson-child-item data'>
                                  {progress === 100 ?
                                   <span className='checked-icon ms-2'>
                                    <TickHere />
                                  </span> 
                                  :
                                  <CircularProgress className="ms-2" size="sm" thickness={5} determinate value={progress} title={progress+"%"} ></CircularProgress>
                                  }



                                  <span className='w-100'>
                                      <div className='section-title pb-1'>
                                    <h5> {indx + 1}. {subSection.name}  </h5>
                                    <Tooltip title={subSection.versions[0].data.moreInfo}>
                                      <span><InfoIcon/></span>
                                    </Tooltip>
                                      
                                      </div>
                                    <div className='d-flex align-items-center justify-content-between'>
                                      <p> {assetTypeIcon[subSection.versions[0].data.lastAsset]} {humanReadable(parseFloat(subSection.versions[0].data.courseDuration) * 60)} </p>

                                      {subSection.versions[0].data.media.length > 0 &&
                                        <div className="dropdown ">
                                          <button onClick={(event) => event.stopPropagation()} className='resource-btn dropdown-toggle' type="button" data-bs-toggle="dropdown" aria-expanded="false"> <FolderIcon /> Resources </button>
                                          <ul className="dropdown-menu">
                                            <div className='drop-menu-list'>
                                              {subSection.versions[0].data.media.map((e, i) => {
                                                return (
                                                  <span key={i + 1} onClick={(event) => { handleClickDownloadFile(e.url); event.stopPropagation() }} >Resource {i + 1}</span>
                                                )
                                              })}
                                            </div>
                                          </ul>
                                        </div>
                                      }

                                    </div>
                                  </span>

                                </div>

                              </div>

                            )



                          })

                          }
                        </div>
                      }
                    </div>

                  )
                })   
            :
            <div className='no-content'>
                <LottiePlayer
                animationData={NoDataFoundAnim}
                style={{ height: 120, marginBottom: 0 , border:"none"}}
              />
              <p>No Content Found</p>
            </div>
            }

          </div>
        </div>

      </div>


    </>
  );
};

export default LMSPlay
